import { createFileRoute } from "@tanstack/react-router";

import { OAuthSelectOrganizationPage } from "~/pages/oauth/select-organization.page";

export const Route = createFileRoute("/oauth/select-organization")({
  // Pass search params through untouched — the signed OAuth authorization
  // query lives here and is auto-forwarded by `oauthProviderClient`.
  validateSearch: (search: Record<string, unknown>) => search,
  component: OAuthSelectOrganizationPage,
});
